/* import __COLOCATED_TEMPLATE__ from './card-chip-multiple.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();